/* ============================================================
 * TF · Portal — world-stage: resolución de mundo + wipe + threshold.
 * Reproducción fiel (handoff §2/§9). Resolución: ?world → guardado → default.
 * Wipe espacial (clip-path 900ms, nunca crossfade). Un solo CTA visible; el
 * mundo inactivo queda aria-hidden + fuera del tab order. transform/clip-path only.
 * ============================================================ */
(function () {
  "use strict";
  if (window.__tfPortal) return; window.__tfPortal = true;

  function ready(fn) { document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    var stage = document.querySelector("[data-tf-stage]");
    if (!stage) return;
    var KEY = "tf-world";
    var params = new URLSearchParams(location.search);
    var world = params.get("world") || null;
    try { world = world || localStorage.getItem(KEY); } catch (e) {}
    world = world || stage.getAttribute("data-tf-default") || "street";
    if (world !== "street" && world !== "sport") world = "street";

    // Escenas bajo el hero: sólo se muestra el mundo activo (prototipo: isStreet/isSport)
    function applyScenes(w) {
      document.querySelectorAll("[data-tf-portal-scene]").forEach(function (sec) {
        sec.style.display = sec.getAttribute("data-tf-world") === w ? "block" : "none";
      });
    }

    function apply(w, save) {
      stage.setAttribute("data-tf-active", w);
      applyScenes(w);
      stage.querySelectorAll("[data-tf-world-pane]").forEach(function (p) {
        var on = p.getAttribute("data-tf-world-pane") === w;
        p.setAttribute("aria-hidden", on ? "false" : "true");
        p.querySelectorAll("a, button").forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      });
      var other = w === "street" ? "sport" : "street";
      var peek = stage.querySelector("[data-tf-threshold-peek]");
      if (peek) {
        var idx = peek.querySelector(".tf-threshold__peek-idx");
        var name = peek.querySelector(".tf-threshold__peek-name");
        if (idx) idx.textContent = other === "sport" ? "Mundo 02" : "Mundo 01";
        if (name) name.textContent = other === "sport" ? "Sportswear" : "Streetwear";
      }
      if (save) { try { localStorage.setItem(KEY, w); } catch (e) {} }
    }

    apply(world, false);

    var th = stage.querySelector("[data-tf-threshold]");
    if (th) th.addEventListener("click", function () {
      apply(stage.getAttribute("data-tf-active") === "street" ? "sport" : "street", true);
    });

    // En el Portal, click en un mundo del header cambia de mundo (no navega)
    document.querySelectorAll("[data-tf-world-trigger]").forEach(function (t) {
      t.addEventListener("click", function (e) { e.preventDefault(); apply(t.getAttribute("data-tf-world-trigger"), true); });
    });
  });
})();
